import { useLayoutEffect } from "react";

export function useWindowSize() {
  // We need this hacky way of setting a viewHeight, because of this issue:
  // https://bugs.webkit.org/show_bug.cgi?id=141832#c5
  // The way to use it is like this, with a helper function:
  // Replace:   height: 90vh;
  // With:      height: ${getWindowHeight(90)};
  useLayoutEffect(() => {
    function updateSize() {
      const viewHeight = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${viewHeight}px`);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
}
